import { useEffect, useState } from 'react';

import { TTabOption } from './tabs.types';

const useValidateTabs = (tabs: TTabOption[]) => {
  const [filteredTabs, setFilteredTabs] = useState<TTabOption[]>([]);

  useEffect(() => {
    const valueCounts: Record<string, number> = {};
    // make sure each tab has a unique value
    const values = tabs.filter((tab) => {
      if (typeof tab.value !== 'string' || !tab.value?.trim()?.length) {
        console.warn('Tabs must have a valid string value but received', JSON.stringify(tab, null, 2));
        return false;
      }
      // if the value is not unique, warn the user
      if (valueCounts[tab.value] > 0) {
        console.warn(`Duplicate tab value found: ${tab.value}`);
        return false;
      }

      if (!(tab.value in valueCounts)) {
        valueCounts[tab.value] = 0;
      } else {
        valueCounts[tab.value]++;
      }

      return true;
    });

    setFilteredTabs(values);
  }, [tabs]);

  return filteredTabs;
};

export default useValidateTabs;
